import React from 'react';
import { IconProps } from '.';

const SvgHomeFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M21 20V9.522a2 2 0 0 0-.829-1.621l-7-5.056a2 2 0 0 0-2.342 0l-7 5.056A2 2 0 0 0 3 9.522V20a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 1 4 0v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2Z'
      />
    </svg>
  );
};

export default SvgHomeFillRounded;
